import "./desktop/StrategyDesktop.scss";
import "./tablet/StrategyTablet.scss";
import "./mobile/StrategyMobile.scss";